import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputLabelComponent } from '@common/components/input/input-label/input-label.component';
import { environment } from '@environments/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import {
    CustomMessagesComponent,
    FileInfo,
    FileSelectComponent,
    KENDO_UPLOAD,
    SelectEvent
} from '@progress/kendo-angular-upload';
import { BaseInputComponent } from '../base-input/base-input.component';
import { FileInputConfig } from '../input.type';

/**
 * File input component.
 * @param isMultiple - Whether multiple files can be selected.
 * @param showFileList - Whether the file list should be shown.
 * @param restrictions - The file restrictions.
 */
@Component({
    selector: 'app-file-input',
    templateUrl: './file-input.component.html',
    providers: [{ provide: BaseInputComponent, useExisting: FileInputComponent }],
    imports: [
        InputLabelComponent,
        FileSelectComponent,
        TranslatePipe,
        TooltipDirective,
        KENDO_UPLOAD,
        CustomMessagesComponent,
        NgClass,
        FormsModule
    ]
})
export class FileInputComponent extends BaseInputComponent<{ content: string; name: string }[]> {
    @Input() isMultiple: FileInputConfig['isMultiple'];
    @Input() showFileList: FileInputConfig['showFileList'] = true;
    @Input() restrictions: FileInputConfig['restrictions'] = environment.settings.input.fileRestrictions;
    @Input() dropZone: FileInputConfig['dropZone'] = false;

    onFileSelected(event: SelectEvent) {
        event.files.forEach((file: FileInfo) => {
            this.loadFile(file, (content) => {
                const value = this.value();
                if (!this.isMultiple) {
                    value.splice(0, value.length);
                }
                value.push({ content, name: file.name });
                this.setValue(value);
            });
        });
    }

    private loadFile(file: FileInfo, onLoaded: (content: string) => void) {
        if (file.validationErrors?.length) {
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            const str = event.target.result as string; // data:text/plain;base64,[CONTENT]
            onLoaded(str.substring(str.indexOf(',') + 1));
        };
        reader.readAsDataURL(file.rawFile);
    }
}
